<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [chipItems]="chipItems"
    [paginatedData]="paginatedData"
    [isTableLoading]="isLoading"
  >
  </kodit-table>
</kodit-page>
